export default __webpack_public_path__ + "static/checkmark-a564974a29588359d45b7ec0e1aab92a.png";